import { apiSlice } from "../baseApi";

import type { AdminV2CrmPeopleListResponse } from "@/types/adminV2";

/** Closed server-owned populations: never accept card clauses or contact IDs. */
export const ENTRY_POINT_OVERLAP_KEYS = [
  "health-did-not-connect--connected",
  "health-did-not-generate--report-sent",
  "health-not-opened-offer--saw-offer",
  "health-did-not-start-checkout--left-checkout",
  "health-not-opened-offer--trial-started",
  "health-did-not-start-checkout--trial-started",
  "health-left-checkout--trial-started",
  "health-card-failed--did-not-continue",
  "trial-card-failed--did-not-continue",
  "trial-signups-only-card-failed--did-not-continue",
] as const;

export type EntryPointOverlapKey = (typeof ENTRY_POINT_OVERLAP_KEYS)[number];
export interface EntryPointOverlapQuery {
  key: EntryPointOverlapKey;
  limit?: number;
  offset?: number;
  sortBy?: "full_name" | "last_activity_at";
  sortDirection?: "asc" | "desc";
}

export const buildEntryPointOverlapPath = (key: EntryPointOverlapKey) => {
  if (!ENTRY_POINT_OVERLAP_KEYS.includes(key))
    throw new Error("Unknown entry point overlap");
  return `/crm/entry-point-overlaps/${key}`;
};

export const buildEntryPointOverlapRequest = ({
  key,
  limit,
  offset,
  sortBy,
  sortDirection,
}: EntryPointOverlapQuery) => ({
  url: `/admin/v2${buildEntryPointOverlapPath(key)}`,
  // Explicit allowlist also keeps untyped callers from forwarding filters.
  params: { limit, offset, sortBy, sortDirection },
});

const api = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminV2EntryPointOverlap: builder.query<
      AdminV2CrmPeopleListResponse,
      EntryPointOverlapQuery
    >({
      query: buildEntryPointOverlapRequest,
      providesTags: [{ type: "AdminV2CrmPeople", id: "LIST" }],
    }),
  }),
});

export const { useGetAdminV2EntryPointOverlapQuery } = api;
